import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { StandardOS } from "../../models/calculator-models/standard-os.model";
import { StandardPremium } from "../../models/calculator-models/stamdard-premium.model";
import { SecurityOS } from "../../models/calculator-models/security-os.model";
import { SecurityPremium } from "../../models/calculator-models/security-premium.model";
import { ScholarshipOS } from "../../models/calculator-models/scholarship-os.model";
import { ScholarshipPremium } from "../../models/calculator-models/scholarship-premium";

@Injectable({
    providedIn: 'root'
})
export class CalculatorVIPService {

    constructor(
        private httpClient: HttpClient
    ) { }

    calculateStandartOS(standardOS: StandardOS) {
        return this.httpClient.post('api/calculator/standardvip', standardOS.data);
    }

    calculateStandardPremium(standardPremium: StandardPremium) {
        return this.httpClient.post('api/calculator/standardpremiumvip', standardPremium.data)
    }

    calculateSecurityOS(securityOS: SecurityOS) {
        return this.httpClient.post('api/calculator/riskvip', securityOS.data);
    }

    calculateSecurityPremium(securityPremium: SecurityPremium) {
        return this.httpClient.post('api/calculator/riskpremiumvip', securityPremium.data);
    }

    calculateScholarshipOS(scholarshipOS: ScholarshipOS) {
        return this.httpClient.post('api/calculator/grantvip', scholarshipOS.data);
    }

    calculateScholarshipPremium(scholarshipPremium: ScholarshipPremium) {
        return this.httpClient.post('api/calculator/grantpremiumvip', scholarshipPremium.data)
    }

}